/**
 * UNESCO ISCED-F 2013 - International Standard Classification of Education
 * Fields of Education and Training (Broad field level)
 */

export const unescoSubjects = [
  { code: "00", label: "Generic programmes and qualifications", parent: null },
  { code: "01", label: "Education", parent: null },
  { code: "02", label: "Arts and humanities", parent: null },
  { code: "03", label: "Social sciences, journalism and information", parent: null },
  { code: "04", label: "Business, administration and law", parent: null },
  { code: "05", label: "Natural sciences, mathematics and statistics", parent: null },
  { code: "06", label: "Information and Communication Technologies (ICTs)", parent: null },
  { code: "07", label: "Engineering, manufacturing and construction", parent: null },
  { code: "08", label: "Agriculture, forestry, fisheries and veterinary", parent: null },
  { code: "09", label: "Health and welfare", parent: null },
  { code: "10", label: "Services", parent: null },
  { code: "99", label: "Field unknown", parent: null },
];

export default unescoSubjects;
